export default {"src":"/_next/static/media/instant-real-quotes.1d444957.svg","height":33,"width":29};